import {ILeadType} from "../../types/lead/ILeadType";

export const lead = {
    getLeadType: (vendorId: number | null, offerId: number | null, propertyId: number | null): ILeadType => {
        if (vendorId && offerId && propertyId) {
            return "property";
        }

        if (vendorId && offerId && !propertyId) {
            return "offer";
        }

        return "vendor";
    }
};
import {ILeadType} from "../../types/lead/ILeadType";

export const lead = {
    getLeadType: (vendorId: number | null, offerId: number | null, propertyId: number | null): ILeadType => {
        if (vendorId && offerId && propertyId) {
            return "property";
        }

        if (vendorId && offerId && !propertyId) {
            return "offer";
        }

        return "vendor";
    }
};
